import { render, staticRenderFns } from "./VideoContentItem.vue?vue&type=template&id=cf679182&scoped=true"
import script from "./VideoContentItem.vue?vue&type=script&lang=js"
export * from "./VideoContentItem.vue?vue&type=script&lang=js"
import style0 from "./VideoContentItem.vue?vue&type=style&index=0&id=cf679182&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf679182",
  null
  
)

export default component.exports